import { FC, ReactElement } from "react";
import { Check, Info, TriangleAlert, Ban } from "lucide-react";
import { NotificationType } from ".";
import { LARGE_ICON_SIZE_STYLES } from "../../ui/styles";

type NotificationTypeIconProps = {
  type: NotificationType;
};

const generalIconStyle = `${LARGE_ICON_SIZE_STYLES} text-white`;

const notificationTypeIcons: Record<NotificationType, ReactElement> = {
  Info: <Info className={generalIconStyle} />,
  Error: <Ban className={generalIconStyle} />,
  Warning: <TriangleAlert className={generalIconStyle} />,
  Success: <Check className={generalIconStyle} />,
};

export const NotificationTypeIcon: FC<
  React.PropsWithChildren<NotificationTypeIconProps>
> = ({ type }: NotificationTypeIconProps) => notificationTypeIcons[type];
